module.exports = __webpack_public_path__ + "static/media/oluseyiakinnibosun.74d60956.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/oluseyiakinnibosun.webp
// module id = 635
// module chunks = 0